import { ENUM_TRIP_STATUS } from 'utils/enum';
import { ExtendedFilterType } from './types';
import { TripHistoryType } from 'models/trip-history.model';

const getCompletedTrips = (tripHistory: TripHistoryType[]) =>
  tripHistory?.filter(({ status }) => status);
const getFailedTrips = (tripHistory: TripHistoryType[]) =>
  tripHistory?.filter(({ status }) => !status);

export const StatusFilterConfig = (tripHistory: TripHistoryType[], status: ExtendedFilterType) => {
  const statusMapping: Record<
    ENUM_TRIP_STATUS | 'All',
    (tripHistory: TripHistoryType[]) => TripHistoryType[]
  > = {
    completed: getCompletedTrips,
    failed: getFailedTrips,
    All: (tripHistory: TripHistoryType[]) => tripHistory
  };
  return statusMapping[status](tripHistory);
};
